import bcrypt from "bcryptjs";

import updateDocumentData from "../../utils/updateDocumentData";

import { Contractor } from "./types/Contractor";

export default async function updateContractor(firebase, ref, data) {
	if (data.password) {
		data.password = await bcrypt.hash(data.password, 10);
	}

	if (!data.password) {
		delete data.password;
	}

	const contractorData = Contractor.partial().parse(updateDocumentData(firebase, data));

	return ref.set(contractorData, { merge: true });
}
